interface DropdownCheckIconProps {
  className?: string
}

export function DropdownCheckIcon({ className }: DropdownCheckIconProps) {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width={15}
      height={11}
      viewBox="0 0 15 11"
      fill="none"
      aria-hidden="true"
      focusable="false"
    >
      <path
        d="M14.0833 0.75L4.91667 9.91667L0.75 5.75"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
